import React, { useState } from 'react';
import CommonTable from '../../../global/table';
import CommonCardView from '../../../global/cardView';
import NoRecordFound from '../../../global/noRecordFound';
import CommonDrawer from '../../../global/drawer';
import { formatDateTime, formatLeadSource } from '../../../../utils/functions';
import EnhancedNewLeadAlertCardView from './EnhancedNewLeadAlertCardView';
import EnhancedNewLeadAlertDetails from './EnhancedNewLeadAlertDetails';

const EnhancedNewLeadAlertList = ({
    isLoading,
    newLeadAlertData,
    sort,
    setSort,
    viewType
}) => {
    const [detailsDrawer, setDetailsDrawer] = useState({
        show: false,
        data: null
    });

    const columns = [
        {
            title: "Lead Source",
            dataIndex: "leadSourceId",
            key: "leadSourceId",
            render: (text, record) => (
                <span className="capitalize">
                    {formatLeadSource(record?.leadSourceId?.leadSource)}
                </span>
            )
        },
        {
            title: "Alert (Email/Sms)",
            dataIndex: "alertEmail",
            key: "alertEmail",
            render: (text, record) => record.alertEmail || record.alertSms || "-"
        },
        {
            title: "Lead(s)",
            dataIndex: "leadsImported",
            key: "leadsImported",
        },
        {
            title: "Imported At",
            dataIndex: "createdAt",
            key: "createdAt",
            render: (text) => formatDateTime(text)
        }
    ];

    const handleRowClick = (record) => {
        setDetailsDrawer({ show: true, data: record });
    };

    return (
        <>
            {newLeadAlertData && newLeadAlertData.length > 0 ? (
                <>
                    {viewType === "LIST" ? (
                        <CommonTable
                            columns={columns}
                            data={newLeadAlertData.map((item, index) => ({
                                key: item._id || index,
                                ...item
                            }))}
                            sort={sort}
                            setSort={setSort}
                            onRowClick={handleRowClick}
                        />
                    ) : (
                        <CommonCardView>
                            {newLeadAlertData.map((record, index) => (
                                <EnhancedNewLeadAlertCardView
                                    key={record._id || index}
                                    record={record}
                                    onCardClick={handleRowClick}
                                />
                            ))}
                        </CommonCardView>
                    )}
                </>
            ) : (
                <NoRecordFound message="No lead alerts found." />
            )}

            {detailsDrawer.show && (
                <CommonDrawer
                    open={detailsDrawer.show}
                    setOpen={(val) => setDetailsDrawer(prev => ({ ...prev, show: val }))}
                    title="New Lead Alert Detail"
                    width="600px"
                >
                    <EnhancedNewLeadAlertDetails data={detailsDrawer.data} />
                </CommonDrawer>
            )}
        </>
    );
};

export default EnhancedNewLeadAlertList;
